import { Form, FormInstance } from 'antd';
import React, { useState } from 'react';

import ReadyToMapItem from '@components/quick-map/components/ReadyToMap/ReadyToMapItem';

import styles from './index.less';

const initialValue = {
  events: [],
};

interface IReadyToMapGroups {
  form: FormInstance;
  repeatedNames: string[];
}

const ReadyToMapGroups: React.FC<IReadyToMapGroups> = ({ form, repeatedNames }) => {
  const fieldsValue = Form.useWatch('events', form);
  const [activeItem, setActiveItem] = useState<string>('');

  const onActiveItem = (curField) => {
    setActiveItem(curField?.raw_event ?? '');
  };

  return (
    <Form
      name="ready_to_map"
      form={form}
      initialValues={initialValue}
      className={styles.mapGroupsForm}
    >
      <Form.List name={'events'}>
        {(fields, { remove }) => {
          if (fields.length === 0) {
            return (
              <div className={styles.emptyListWrapper}>
                Please select the event you want to map from the left...
              </div>
            );
          }
          return (
            <>
              {fields.map((field, index) => {
                const { key, name, ...restField } = field;
                const curField = fieldsValue?.[index];
                const active = curField?.raw_event === activeItem;
                return (
                  <ReadyToMapItem
                    key={key}
                    name={name}
                    restField={restField}
                    itemData={curField}
                    active={active}
                    onActive={onActiveItem}
                    form={form}
                    remove={() => remove(index)}
                    repeatedNames={repeatedNames}
                  />
                );
              })}
            </>
          );
        }}
      </Form.List>
    </Form>
  );
};

export default ReadyToMapGroups;
